import { useState  } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css"; // Works with v0.7.1
 


import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { tokens } from "../../theme";

// MUI Icons (corrected names and paths)
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlinedIcon from "@mui/icons-material/PieChartOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import CloseIcon from '@mui/icons-material/Close';
 import useMediaQuery from '@mui/material/useMediaQuery';

const Item = ({title, to , icon, selected, setSelected}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <MenuItem active={selected === title}
            style={{ color: colors.gray[100] }}
            onClick={() => setSelected(title)}
            icon={icon}>
            
            <Typography>{ title}</Typography>
            <Link to={to} />
        </MenuItem>
    )
}

const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
 
    const [selected, setSelected] = useState("Dashboard");
     const isMobile = useMediaQuery('(max-width:600px)');
    
    

    return (
        <Box
            sx={{
                
            "& .pro-sidebar-inner": {
                background: `${colors.primary[800]} !important`
            },
            "& .pro-icon-wrapper": {
                backgroundColor:"transparent !important"
            },
            "& .pro-inner-item": {
                padding: "5px 35px 5px 20px !important"
            },
            "& .pro-inner-item:hover":
                { color: "#868dfb !important" },
            "& .pro-menu-item.active": {
                color: "#6879fa !important"
                }
                ,
                position:  isMobile?"fixed":"sticky",
                top: "0px",
                left:"0px",
                zIndex: "100",
                overflow: "hidden",
                overflowY: "scroll",
                height: "100vh",
                 
            }}>
        
            <ProSidebar collapsed={isCollapsed} breakPoint= {isCollapsed?"md":""} >
                <Menu iconShape="square"> 
                    {/* LOGO AND MENU ICON */}
                    <MenuItem onClick={() => setIsCollapsed(!isCollapsed)}
                        icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
                        style={{
                            margin: "10px 0 20px 0",
                            color: colors.gray[100],
                        }}
                    > 
                        {!isCollapsed && (<Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            ml="15px"
                        >
                            <Typography variant="h3" color={colors.gray[100]}>
                                ADMINIS
                            </Typography>
                            <IconButton onClick={()=>setIsCollapsed(!isCollapsed)}>
                                {isMobile?<CloseIcon/>:<MenuOutlinedIcon/>}
                            </IconButton>

                        </Box>)}
                    </MenuItem>
                
                    {/* USER */}
                    {!isCollapsed && (
                        <Box mb="25px">
                            <Box display="flex" justifyContent="center" alignItems="center">
                                <img alt="Profile-user"
                                    width="100px"
                                    height="100px"
                                    src="../../assets/team-1.png"
                                    style={{cursor:"pointer", borderRadius:"50%"}}
                                />
                            </Box>
                    
                            <Box textAlign="center">
                                <Typography variant="h2" color={colors.gray[100]} fontWeight="bold" sx={{m:"10px 0 0 0"}}>Fares Ahmed</Typography>
                                <Typography variant="h5" color={colors.greenAccent[500]}>VP Fancy Admin</Typography>
                            </Box>
                        </Box>
                    )}

                    {/* MENU ITEMS */}
                    <Box paddingLeft={isCollapsed ? undefined : "10%"}>
                        <Item title="Dashboard" to="/"
                            icon={<HomeOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Typography
                            variant="h6"
                            color={colors.gray[300]}
                            sx={{m:"15px 0 5px 20px"}}
                        >Data</Typography>
                        <Item title="Manage Team" to="/team"
                            icon={<PeopleOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item title="Contacts Information" to="/contacts"
                            icon={<HomeOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item title="Invoices Balances" to="/invoices"
                            icon={<ReceiptOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                         <Typography
                            variant="h6"
                            color={colors.gray[300]}
                            sx={{m:"15px 0 5px 20px"}}
                        >pages</Typography>
                        <Item title="Profile Form" to="/form"
                            icon={<PersonOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item title="Calender" to="/calender"
                            icon={<CalendarTodayOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item title="FAQ Page" to="/faq"
                            icon={<HelpOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                         <Typography
                            variant="h6"
                            color={colors.gray[300]}
                            sx={{m:"15px 0 5px 20px"}}
                        >charts</Typography>
                        <Item title="Bar Chart" to="/bar"
                            icon={<BarChartOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item title="Pie Chart" to="/pie"
                            icon={<PieChartOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item title="Line Chart" to="/line"
                            icon={<TimelineOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item title="Geography Chart" to="/geography"
                            icon={<MapOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        
                    </Box>
                </Menu>
            </ProSidebar>
        </Box>
            
);
};

export default Sidebar;
